
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invest/companies",
      function () {
        return require("private-next-pages/invest/companies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invest/companies"])
      });
    }
  